module.exports = __webpack_public_path__ + "img/4.24fe76c5.png";